// 请求接口地址 如果没有配置自动获取当前网址路径
// const VUE_APP_API_URL = process.env.VUE_APP_BASE_API || `${location.origin}`;
// const VUE_APP_WS_URL =
//   process.env.VUE_APP_WS_URL ||
//   (location.protocol === "https" ? "wss" : "ws") + ":" + location.hostname;

/**
 * get api base url
 * @param type default
 */
export function getApiBaseUrl(type: string) {
  let APP_API_URL: string | undefined = undefined;
  let APP_WS_URL: string | undefined = undefined;

  if (type === "default") {
    APP_API_URL = process.env.NEXT_PUBLIC_APP_BASE_API;
    APP_WS_URL = process.env.NEXT_PUBLIC_APP_BASE_OSS;
  }

  const prefix = "/pointsmall";

  return {
    // 服务器地址
    httpUrl: APP_API_URL,
    // 接口请求地址
    apiBaseURL: APP_API_URL + prefix + "/api",
    // socket连接
    wsSocketUrl: APP_WS_URL,
  };
}
